// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"2632ffb8","774":"0d4a686d","787":"f66536a1"}[chunkId] + ".chunk.js";
};